import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, LayoutDashboard, UserRound, LogOut } from "lucide-react";
import { Sheet, SheetContent, SheetTrigger, SheetTitle } from "@/components/ui/sheet";
import { Logo } from "@/components/site/Logo";
import { useMe } from "@/lib/site";

const LINKS = [
  { to: "/", label: "الرئيسية", id: "home" },
  { to: "/courses", label: "جميع الدورات", id: "courses" },
  { to: "/upcoming", label: "الدورات القادمة", id: "upcoming" },
  { to: "/about", label: "من نحن", id: "about" },
  { to: "/contact", label: "تواصل معنا", id: "contact" },
];

const linkCls = ({ isActive }) =>
  `relative px-1 py-2 text-[15px] font-medium transition-colors ${isActive ? "text-[var(--copper)]" : "text-[var(--ink)] hover:text-[var(--copper)]"}`;

const AuthArea = ({ mobile }) => {
  const { me, signOut } = useMe();
  const sfx = mobile ? "-m" : "";
  if (!me)
    return (
      <div className={`flex ${mobile ? "flex-col items-stretch" : "items-center"} gap-3`}>
        <Link to="/sign-in" data-testid={`nav-signin${sfx}`} className="btn-gold-outline !py-2 !px-5 text-sm">تسجيل الدخول</Link>
        <Link to="/sign-up" data-testid={`nav-signup${sfx}`} className="btn-copper !py-2 !px-5 text-sm">إنشاء حساب</Link>
      </div>
    );
  return (
    <div className={`flex ${mobile ? "flex-col items-stretch" : "items-center"} gap-3`}>
      {me.role === "admin" && (
        <Link to="/admin" data-testid={`nav-admin${sfx}`} className="btn-gold-outline !py-2 !px-4 text-sm"><LayoutDashboard size={16} />لوحة التحكم</Link>
      )}
      <Link to="/account" data-testid={`nav-account${sfx}`} className="btn-copper !py-2 !px-4 text-sm"><UserRound size={16} />حسابي</Link>
      <button onClick={() => { signOut(); window.location.replace("/"); }} data-testid={`nav-logout${sfx}`} className="inline-flex items-center justify-center gap-1 text-sm text-[var(--muted-ink)] hover:text-red-600 px-2"><LogOut size={16} />خروج</button>
    </div>
  );
};

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  return (
    <header className="sticky top-0 z-40 bg-[#FAF7F2]/85 backdrop-blur-xl border-b border-[var(--line)]" data-testid="site-navbar">
      <div className="container-x h-20 flex items-center justify-between gap-4">
        <Logo />
        <nav className="hidden lg:flex items-center gap-7">
          {LINKS.map((l) => (
            <NavLink key={l.to} to={l.to} end className={linkCls} data-testid={`nav-${l.id}`}>{l.label}</NavLink>
          ))}
        </nav>
        <div className="hidden lg:block"><AuthArea /></div>
        <div className="lg:hidden flex items-center gap-2">
          <Sheet open={open} onOpenChange={setOpen}>
            <SheetTrigger asChild>
              <button data-testid="nav-mobile-toggle" className="p-2 rounded-lg border border-[var(--line)] bg-white" aria-label="القائمة"><Menu size={22} /></button>
            </SheetTrigger>
            <SheetContent side="right" className="bg-[#FAF7F2] w-[85%]" dir="rtl">
              <SheetTitle className="sr-only">القائمة</SheetTitle>
              <div className="flex flex-col gap-2 mt-10" onClick={() => setOpen(false)}>
                {LINKS.map((l) => (
                  <NavLink key={l.to} to={l.to} end className={linkCls} data-testid={`nav-m-${l.id}`}>{l.label}</NavLink>
                ))}
                <div className="mt-6"><AuthArea mobile /></div>
              </div>
            </SheetContent>
          </Sheet>
        </div>
      </div>
    </header>
  );
};
